import OptionGroupList from '../collections/optionGroupList';
import SkuList from '../collections/skuList';
import namespace from '../../upi/namespace';

var app = namespace( 'apps.productpage' );

var Configuration = Backbone.Model.extend( {

    defaults: {
        'name': '',
        'type': null,
        'groupId': null,
        'parentGroupId': null,
        'skuId': null,
        'usageId': null,
        'images': [],
        'options': [],
        'groups': [],
        'selected': false,
        'label': 'One' // <= default label
    },

    initialize: function () {
        var self = this;

        this.skuList = new SkuList( this.getSkuList() );

        // Configuration keeps track of it's optionGroupsList for easy access to selected options for validation
        if ( this.hasOptionGroups() ) {
            this.optionGroupList = new OptionGroupList( this.getOptionGroups(), {skuList: this.skuList} );

            this.listenTo( this, 'change:selected', function () {
                app.mediator.trigger( 'configuration:select', this );
                this.optionGroupList.clearSelectedOptions();
            }, this );

            this.listenTo( this.optionGroupList, 'change:option', function () {
                this.trigger( 'change:option' );
            } );

            // default PriceModuleView to this configurations skuList when an option selection gets invalidated
            this.listenTo( this.optionGroupList, 'option:invalidated', function () {
                //                        app.priceModuleSkuList.reset( this.skuList.models );
                app.mediator.trigger( 'set:skulist', this.skuList.models );
            } );
        }
    },

    hasGroups: function () {
        var groups = this.get( 'groups' );
        return groups && groups.length > 0;
    },

    hasOptionGroups: function () {
        var optionGroups = this.get( 'optionGroups' );
        return optionGroups && optionGroups.length > 0;
    },

    hasParent: function () {
        return this.get( 'parentGroupId' ) !== null;
    },

    hasSelection: function () {
        return false;
    },

    /**
     * getGroups
     * Get list of OptionGroup models that belong to this configuration
     * @returns {Array|null}
     */
    getGroups: function () {
        if ( this.collection && this.hasGroups() ) {
            var groupIds = this.get( 'groups' );
            return this.collection.models.filter( function ( item ) {
                return groupIds.indexOf( item.get( 'groupId' ) ) > -1;
            } );
        }
        else {
            return null;
        }
    },

    getFirstGroupItem: function () {
        if ( this.collection && this.hasGroups() ) {
            var id = this.get( 'groups' )[0];
            // return the first group or sku item in configuration collection
            return this.collection.filter( function ( item ) {
                return item.get( 'groupId' ) === id || item.get( 'skuId' ) === id;
            } )[0];
        }
        else {
            return null;
        }
    },

    select: function () {

        // trigger proper selection type for configuration
        if ( this.hasGroups() ) {
            var configuration = this.getFirstGroupItem();
            configuration.select();
        }
        else {
            app.mediator.trigger( 'update:route', this );

            if ( this.hasOptionGroups() ) {
                this.trigger( 'select:configuration', this );
            }
            else {
                this.trigger( 'select:sku', this );
            }
            // clear out previous selection and ensure only one configuration is selected at a time
            this.trigger( 'select:one', this );
        }
    },

    getGroupLabel: function () {
        return (this.collection && this.hasParent())
            ? this.collection.findWhere( {groupId: this.get( 'parentGroupId' )} ).get( 'label' )
            : '';
    },

    getOptionGroups: function () {
        var groupIds = this.get( 'optionGroups' ) || [];

        return _.filter( app.product.get( 'optionGroups' ), function ( item ) {
            return groupIds.indexOf( item.id ) > -1;
        } );
    },

    getSkuList: function () {
        var list = [];

        if ( this.get( 'groupId' ) ) {
            list = app.skuList.filter( ( sku ) => {
                return sku.get( 'groupId' ) === this.get( 'groupId' );
            } );
        }
        else if ( this.get( 'skuId' ) ) {
            list = app.skuList.findWhere( {id: this.get( 'skuId' )} );
        }

        return list;
    },

    getSelectedSku: function () {
        if ( this.hasGroups() ) {
            // groups do not have skus
            return null;
        }
        //                console.log( 'get selected sku', this.get( 'type' ) );
        return ('sku' === this.get( 'type' ))
            ? this.skuList.findWhere( {id: this.get( 'skuId' )} )
            : this.skuList.getSkuByOptions( this.optionGroupList.getSelected() );
    },

    // todo: set a validationErrors object on configuration, with details about what went wrong
    // to allow application to handle accordingly
    validate: function ( opt ) {
        opt = opt || {};

        if ( this.hasGroups() ) {
            // this is a group not a configuration
            console.log( '@Configuration validation failed: group requires a configuration selection' );

            var err = {
                type: 'group requires a configuration selection',
                message:  upi.i18n.getTextFromKey('lbl-pleaseSelect') + ' ' + this.get( 'label' )
            };

            switch ( opt.onError ) {
                case 'showerror':
                    this.trigger( 'error', err );
                    break;
                case 'showhint':
                    app.mediator.trigger( 'tooltip:addsku', err );
                    break;
                default:
                // fail silent
            }

            return false;
        }
        if ( this.hasOptionGroups() ) {
            return this.optionGroupList.validate( opt );
        }

        return true;
    }

} );

export default Configuration;
